// extracted by mini-css-extract-plugin
module.exports = {"ResturantHolder":"Resturants_ResturantHolder__1Q0_l","resturanImg":"Resturants_resturanImg__3Dbl5"};